
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcFormContainer as ObcFormContainerElement} from '@oicl/openbridge-webcomponents/dist/components/form-container/form-container.js';
 
 
 

 
 export const ObcFormContainer = createComponent({
   react: React,
   tagName: 'obc-form-container',
   elementClass: ObcFormContainerElement,
   events: {
     
   }
  });
 
 